const Breakpoints = {
    SM: 360,
    MD: 1024,
    LG: 1440,
    XL: 1920,
}

// Media queries
export const mq = {
    XS_ONLY: `(max-width: ${Breakpoints.SM - 1}px)`,
    SM_MIN: `(min-width: ${Breakpoints.SM}px)`,
    SM_ONLY: `(min-width: ${
        Breakpoints.SM
    }px) and (max-width: ${Breakpoints.MD - 1}px)`,
    SM_MAX: `(max-width: ${Breakpoints.MD - 1}px)`,
    MD_MIN: `(min-width: ${Breakpoints.MD}px)`,
    MD_ONLY: `(min-width: ${
        Breakpoints.MD
    }px) and (max-width: ${Breakpoints.LG - 1}px)`,
    MD_MAX: `(max-width: ${Breakpoints.LG - 1}px)`,
    LG_MIN: `(min-width: ${Breakpoints.LG}px)`,
    LG_ONLY: `(min-width: ${
        Breakpoints.LG
    }px) and (max-width: ${Breakpoints.XL - 1}px)`,
    LG_MAX: `(max-width: ${Breakpoints.XL - 1}px)`,
    XL_ONLY: `(min-width: ${Breakpoints.XL}px)`,
}

/**
 * @returns {'mobile' | 'tablet' | 'laptop' | 'desktop'} returns the type of a device
 */
export const defineDeviceWidth = () => {
    if (
        window.innerWidth < Breakpoints.MD &&
        window.innerWidth >= Breakpoints.SM
    ) {
        return 'mobile'
    }

    if (
        window.innerWidth < Breakpoints.LG &&
        window.innerWidth >= Breakpoints.MD
    ) {
        return 'tablet'
    }

    if (
        window.innerWidth < Breakpoints.XL &&
        window.innerWidth >= Breakpoints.LG
    ) {
        return 'laptop'
    }
    return 'desktop'
}

export default Breakpoints
